export default "__VITE_ASSET__D6Sm7o8p__"